type WorkflowTable = {
  umibuilder: 'umibuilder'
  analysis: 'analysis'
  upgrades: 'upgrades'
  project: 'project'
  user: 'user'
  error: 'error'
}
export const Workflow: WorkflowTable = {
  umibuilder: 'umibuilder',
  analysis: 'analysis',
  upgrades: 'upgrades',
  project: 'project',
  user: 'user',
  error: 'error',
}
